import * as Apollo from '@apollo/client';

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}

var NotificationChannel;
(function (NotificationChannel) {
  NotificationChannel["EMAIL"] = "EMAIL";
  NotificationChannel["PUSH"] = "PUSH";
})(NotificationChannel || (NotificationChannel = {}));
var NotificationType;
(function (NotificationType) {
  NotificationType["ERROR"] = "ERROR";
  NotificationType["INFO"] = "INFO";
  NotificationType["PROMOTION"] = "PROMOTION";
  NotificationType["SUCCESS"] = "SUCCESS";
  NotificationType["WARNING"] = "WARNING";
})(NotificationType || (NotificationType = {}));
const OnNewNotification = {
  "kind": "Document",
  "definitions": [{
    "kind": "OperationDefinition",
    "operation": "subscription",
    "name": {
      "kind": "Name",
      "value": "OnNewNotification"
    },
    "selectionSet": {
      "kind": "SelectionSet",
      "selections": [{
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "newNotification"
        },
        "selectionSet": {
          "kind": "SelectionSet",
          "selections": [{
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "id"
            }
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "type"
            }
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "notification"
            },
            "selectionSet": {
              "kind": "SelectionSet",
              "selections": [{
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "title"
                }
              }, {
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "body"
                }
              }]
            }
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "topic"
            }
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "data"
            }
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "timestamp"
            }
          }]
        }
      }]
    }
  }]
};

const defaultOptions = {};
/**
 * __useOnNewNotificationSubscription__
 *
 * To run a query within a React component, call `useOnNewNotificationSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnNewNotificationSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnNewNotificationSubscription({
 *   variables: {
 *   },
 * });
 */
function useOnNewNotificationSubscription(baseOptions) {
  const options = _extends({}, defaultOptions, baseOptions);
  return Apollo.useSubscription(OnNewNotification, options);
}

export { NotificationChannel, NotificationType, OnNewNotification, useOnNewNotificationSubscription };
//# sourceMappingURL=index.modern.js.map
